import { AuditableEntity } from '../common';

export interface ShortLink extends AuditableEntity<string> {
  code: string;
  originalUrl: string;
  expiresOn?: string;
}

export enum ShortLinkAccessStatus {
  NotFound = 'NotFound',
  NeedLogin = 'NeedLogin',
  Invalid = 'Invalid',
  Expired = 'Expired',
  Forbidden = 'Forbidden',
  Ok = 'Ok'
}

export interface ShortLinkResponse {
  status: ShortLinkAccessStatus;
  url?: string;
}
